module.exports = __webpack_public_path__ + "img/refresa.2c7fb95e.png";